import { createTheme } from "@mui/material/styles";

/**
 * Tranos brand theme.
 * Primary: #1E3A8A (deep blue) | Accent: #2563EB | Neutral dark: #111827
 * Design system lite — spacing scale: 4, 8, 12, 16, 24, 32 (theme units 0.5, 1, 1.5, 2, 3, 4).
 */
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1E3A8A",
      light: "#2563EB",
      dark: "#1E3A5F",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#2563EB",
      light: "#3B82F6",
      dark: "#1D4ED8",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F1F5F9",
      paper: "#FFFFFF",
    },
    error: { main: "#DC2626" },
    success: { main: "#059669" },
    warning: { main: "#D97706" },
    info: { main: "#2563EB" },
    text: {
      primary: "#111827",
      secondary: "#64748B",
      disabled: "#9CA3AF",
    },
    divider: "rgba(0,0,0,0.08)",
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: "-0.02em" },
    h5: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    body1: { lineHeight: 1.55 },
    body2: { lineHeight: 1.5 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
  spacing: 8,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollBehavior: "smooth",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "8px 20px",
          textTransform: "none",
          fontWeight: 600,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          },
        },
        sizeLarge: {
          padding: "10px 24px",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: "none",
        },
        outlined: {
          borderColor: "rgba(0,0,0,0.08)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          "&.Mui-selected": {
            backgroundColor: "rgba(30, 58, 138, 0.08)",
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          maxWidth: "calc(100vw - 32px)",
        },
      },
    },
  },
});
